import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import RequestsTableColumns from './RequestsTableColumns';

const RequestsTableHeader = ({
  category,
  children,
  columns,
  hideColumns,
  readErrors,
  readStatus,
  requests,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
    >
      {children}
    </TableHeader>
    {!hideColumns && <RequestsTableColumns category={category} items={requests} columns={columns} />}
  </Table.Header>
);

export default RequestsTableHeader;
